<template>
    <div v-if="id">
        <form-header title="Anmeldung" subtitle="als Ensemble zum" :tag="this.formdata.wettbewerb.name"></form-header>

        <ValidationObserver ref="form" v-if="this.formdata.wettbewerb.anmeldungOffen">
            <div>
                <div class="bg-primary">
                    <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                        <transition name="fade">
                            <div class="mt-0 mb-4 bg-red-100 border-2 border-red-200 px-4 py-4 sm:rounded-lg sm:p-4"
                                v-show="formbehaviour.alertrequired">
                                <div class="md:grid md:grid-cols-1 md:gap-3">
                                    <div class="md:col-span-1">
                                        <h3 class="leading-3">
                                            Bitte überprüfen Sie Ihre Eingabe!
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </transition>

                        <form-section title="Angaben zum Ensemble" :subtitle="'Bitte füllen Sie alle notwendigen Felder aus. <br/>Altersgruppe: ' + this.altersgruppe().name">
                            <text-input v-model="wettbewerbsantritt.ensemble.name" label="Ensemblename" columns="5"
                                rules="required"></text-input>
                            <text-input v-model="wettbewerbsantritt.ausbildungsinstitution" label="Ausbildungsinstitution" columns="5"
                                rules="required"></text-input>
                            <drop-down v-if="isOnStageTanz()" :values="[
                                 { id: 865250000, name: 'Kleingruppe (3-10 TN)' },
                            { id: 865250001, name: 'Großgruppe (ab 11 TN)' },
                            ]" v-model="wettbewerbsantritt.wertungskategorie" label="Wertungskategorie" rules="required"
                                columns="4">
                            </drop-down>
                            <drop-down v-if="isOnStageTanz()" :values="[
                                 { id: 865250000, name: 'Ballett' },
                            { id: 865250001, name: 'Moderner/Zeitgenössischer Tanz' },
                            { id: 865250002, name: 'Jazz- und Musicaldance' },
                            { id: 865250003, name: 'Urban style/Hip Hop' },
                            ]" v-model="wettbewerbsantritt.stil" label="Stil" rules="required"
                                columns="4">
                            </drop-down>
                        </form-section>

                        <form-section title="Angaben zur Lehrperson"
                            subtitle="Bitte füllen Sie alle notwendigen Felder aus.">
                            <text-input v-model="wettbewerbsantritt.ensemble.leitung.vorname" label="Vorname" columns="3"
                                rules="required"></text-input>
                            <text-input v-model="wettbewerbsantritt.ensemble.leitung.nachname" label="Nachname" columns="3"
                                rules="required"></text-input>
                            <drop-down :values="[
                                 { id: 865250000, name: 'weiblich' },
                            { id: 865250001, name: 'männlich' },
                            { id: 865250002, name: 'divers' },
                            ]" v-model="wettbewerbsantritt.ensemble.leitung.geschlecht" label="Geschlecht" rules="required"
                                columns="2">
                            </drop-down>
                            <div class="col-span-0 sm:col-span-2">&nbsp;</div>
                            <text-input v-model="wettbewerbsantritt.ensemble.leitung.email" label="E-Mail" columns="3"
                                rules="required|email"></text-input>
                            <text-input v-model="wettbewerbsantritt.ensemble.leitung.telefonnummer" label="Telefonnummer" columns="3"
                                rules="required|numeric"></text-input>
                        </form-section>

                        <div class="mb-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6 border-2"
                        :class="[musikstueckeValid() == '' ? 'border-green-300' : 'border-red-300']"
                        v-if="altersgruppe() && altersgruppe().name != '---' && id.toLowerCase() != 'tanzimgespraech'">
                        In der Altersgruppe <strong>{{ altersgruppe().name }}</strong> ist eine Auftrittszeit zwischen {{ altersgruppe().spielZeitMin }} und {{ altersgruppe().spielZeitMax }}
                        Minuten notwendig.<br /><strong>{{ musikstueckeValid()
}}</strong>
                    </div>
                    

                        <div v-for="(stueck, index) in wettbewerbsantritt.musikstuecke" :key="index"
                            class="mt-2 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
                            <div class="md:grid md:grid-cols-3 md:gap-6">
                                <div class="md:col-span-1">
                                    <h3 class="text-lg font-medium leading-6 text-gray-900">
                                        Programm: Titel {{ index + 1 }}
                                    </h3>
                                    <p class="mt-1 text-sm leading-5 text-gray-500">
                                        Bitte füllen Sie alle notwendigen Felder
                                        aus.
                                    </p>
                                    <button v-show="index != 0" @click="removeEnsembleStueck(index)" type="button"
                                        class="mt-4 inline-flex items-center px-48 sm:px-2 py-1 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-red active:bg-red-700 transition ease-in-out duration-150">
                                        Titel entfernen
                                    </button>
                                </div>
                                <div class="mt-5 md:mt-0 md:col-span-2">
                                    <div class="grid grid-cols-6 gap-6">
                                        <text-input v-model="stueck.titel" label="Titel des Musikstücks" columns="4"
                                            rules="required"></text-input>
                                            <text-input v-model="stueck.titelderChoreographie" label="Titel der Choreographie" columns="4"></text-input>
                                            
                                        <text-input v-model="stueck.dauer" label="Dauer (mm:ss)" columns="2"
                                            rules="required"></text-input>
                                        <text-input v-model="stueck.komponist" label="Komponist" columns="4" rules="required"></text-input>
                                       
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mb-6 mt-2 bg-white shadow px-4 py-4 sm:rounded-lg sm:p-4" v-if="id.toLowerCase() != 'tanzimgespraech'">
                            <div class="md:grid md:grid-cols-3 md:gap-6">
                                <div class="md:col-span-1">&nbsp;</div>
                                <div class="grid grid-cols-6 gap-6">
                                    <div class="col-span-6">
                                        <span class="inline-flex rounded-md shadow-sm">
                                            <button @click="addEnsembleStueck" type="button"
                                                class="inline-flex items-center px-48 sm:px-4 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-green active:bg-green-700 transition ease-in-out duration-150">
                                                weiteren Titel hinzufügen
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="mb-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6 border-2 border-red-300"
                        v-if="altersgruppe() && altersgruppe().name == '---' && id.toLowerCase() != 'tanzimgespraech'">
                        Die Ensemblemitglieder passen leider zu keiner Altersgruppe dieses Wettbewerbs
                    </div>
                        <div v-for="(mitglied, index) in wettbewerbsantritt.ensemble
                            .mitglieder" :key="index" class="mt-2 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
                            <div class="md:grid md:grid-cols-3 md:gap-6">
                                <div class="md:col-span-1">
                                    <h3 class="text-lg font-medium leading-6 text-gray-900">
                                        {{ index + 1 }}. Ensemblemitglied
                                    </h3>
                                    <p class="mt-1 text-sm leading-5 text-gray-500">
                                        Bitte füllen Sie alle notwendigen Felder
                                        aus.
                                    </p>
                                    <button v-show="index > (minimumMitglieder() - 1)" @click="removeEnsembleMitglied(index)" type="button"
                                        class="mt-4 inline-flex items-center px-48 sm:px-2 py-1 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-red active:bg-red-700 transition ease-in-out duration-150">
                                        Mitglied entfernen
                                    </button>
                                </div>
                                <div class="mt-5 md:mt-0 md:col-span-2">
                                    <div class="grid grid-cols-6 gap-6">
                                        <text-input v-model="mitglied.vorname" label="Vorname" columns="3"
                                            rules="required"></text-input>
                                        <text-input v-model="mitglied.nachname" label="Nachname" columns="3"
                                            rules="required"></text-input>
                                        <text-input v-model="mitglied.geburtsdatum" label="Geburtsdatum" columns="2"
                                            rules="required|date"></text-input>
                                        <drop-down :values="[
                                              { id: 865250000, name: 'weiblich' },
                            { id: 865250001, name: 'männlich' },
                            { id: 865250002, name: 'divers' },
                                        ]" v-model="mitglied.geschlecht" label="Geschlecht" rules="required" columns="2">
                                        </drop-down>
                                        <text-input v-model="mitglied.strasse" label="Straße/Nr." columns="5"
                                            rules="required"></text-input>
                                        <text-input v-model="mitglied.plz" label="PLZ" columns="2"
                                            rules="required"></text-input>
                                        <text-input v-model="mitglied.ort" label="Ort" columns="4"
                                            rules="required"></text-input>
                                        <text-input v-model="mitglied.email" label="E-Mail" columns="3"
                                            rules="required|email"></text-input>
                                        <text-input v-model="mitglied.telefonnummer" label="Telefon" columns="3"
                                            rules="required|numeric"></text-input>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mt-2 bg-white shadow px-4 py-4 sm:rounded-lg sm:p-4" v-if="wettbewerbsantritt.ensemble.mitglieder.length < this.maxTeilnehmer()">
                            <div class="md:grid md:grid-cols-3 md:gap-6">
                                <div class="md:col-span-1">&nbsp;</div>
                                <div class="grid grid-cols-6 gap-6">
                                    <div class="col-span-6">
                                        <span class="inline-flex rounded-md shadow-sm">
                                            <button @click="addEnsembleMitglied" type="button"
                                                class="inline-flex items-center px-48 sm:px-4 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-green active:bg-green-700 transition ease-in-out duration-150">
                                                weiteres Mitglied hinzufügen
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="h-6"></div>

                        <form-section title="Anmerkungen">
                            <text-area-input
                                label=""
                                v-model="wettbewerbsantritt.anmerkungen"
                                columns="6"
                                rows="10"
                            />
                        </form-section>
                 

                        <form-section title="Informationspflicht" subtitle="gem. Art. 13 DSGVO">
                            <div class="col-span-6 sm:col-span-5">
                                <text-block :content="textbausteinfuer(
                                    'allgemein.informationspflicht'
                                ).contentPlain
                                    " />
                            </div>
                        </form-section>

                        <form-section title="Bild und Ton">
                            <div class="col-span-6 sm:col-span-5">
                                <text-block :content="textbausteinfuer(
                                    'zustimmung.bildundton'
                                ).contentPlain
                                    " />
                            </div>
                        </form-section>

                        <div class="mt-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6">
                            <div class="md:grid md:grid-cols-3 md:gap-6">
                                <div class="md:col-span-1">&nbsp;</div>
                                <div class="grid grid-cols-6 gap-6">
                                    <div class="col-span-6">
                                        <span class="inline-flex rounded-md shadow-sm">
                                            <button @click="sendAnsuchen()" type="button"
                                                class="inline-flex items-center px-48 sm:px-8 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-green active:bg-green-700 transition ease-in-out duration-150">
                                                Formular absenden
                                            </button>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ValidationObserver>
        <div v-else>
            <form-section>
                <div class="col-span-6 sm:col-span-5">
                    Die Anmeldung zu diesem Wettbewerb ist derzeit nicht möglich
                </div>
            </form-section>
        </div>

        <transition name="fade">
            <div
                class="fixed inset-0 flex items-end justify-center px-4 py-6 pointer-events-none sm:p-6 sm:items-start sm:justify-end">
                <div v-show="formbehaviour.sending"
                    class="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto">
                    <div class="rounded-lg shadow-xs overflow-hidden">
                        <div class="p-4">
                            <div class="flex items-start">
                                <div class="flex-shrink-0">
                                    <svg class="h-6 w-6 text-green-400" fill="none" viewBox="0 0 24 24"
                                        stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                            d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                                    </svg>
                                </div>
                                <div class="ml-3 w-0 flex-1 pt-0.5">
                                    <p class="text-sm leading-5 font-medium text-gray-900">
                                        Validierung erfolgreich.
                                    </p>
                                    <p class="mt-1 text-sm leading-5 text-gray-500">
                                        Übermittle das Formular.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
        <transition name="fade">
            <div v-show="formbehaviour.successful"
                class="fixed bottom-0 inset-x-0 px-4 pb-6 sm:inset-0 sm:p-0 sm:flex sm:items-center sm:justify-center">
                <div v-show="formbehaviour.successful" class="fixed inset-0 transition-opacity">
                    <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                <div v-show="formbehaviour.successful"
                    class="bg-white rounded-lg px-4 pt-5 pb-4 overflow-hidden shadow-xl transform transition-all sm:max-w-sm sm:w-full sm:p-6">
                    <div>
                        <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                            <svg class="h-6 w-6 text-green-600" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                            </svg>
                        </div>
                        <div class="mt-3 text-center sm:mt-5">
                            <h3 class="text-lg leading-6 font-medium text-gray-900">
                                Erfolgreich gesendet.
                            </h3>
                            <div class="mt-2">
                                <p class="text-sm leading-5 text-gray-500">
                                    Vielen Dank für Ihre Anmeldung.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import FormSection from '@/components/forms/FormSection.vue'
import FormHeader from '@/components/forms/FormHeader.vue'

import TextInput from '@/components/inputs/TextInput.vue'

import TextAreaInput from '@/components/inputs/TextAreaInput.vue'
import CheckBox from '@/components/inputs/CheckBox.vue'
import DropDown from '@/components/inputs/DropDown.vue'
import RadioButtonList from '@/components/inputs/RadioButtonList.vue'
import TextBlock from '@/components/inputs/TextBlock.vue'

import FileUpload from '@/components/inputs/FileUpload.vue'

export default {
    name: 'Form',
    inject: ['service'],
    props: {
        id: {
            id: String,
            required: true,
        },
    },
    components: {
        TextInput,
        TextAreaInput,
        CheckBox,
        DropDown,
        FormSection,
        FormHeader,
        RadioButtonList,
        TextBlock,
        FileUpload,
    },
    data: function () {
        return {
            formbehaviour: {

                begleitung1enabled: false,
                showSendModal: false,
                alertrequired: false,
                sending: false,
                successful: false,
            },
            formdata: {
                wettbewerb: {},
                musikschulen: [],
                textbausteine: [],
                instrumente: [],
            },
            wettbewerbsantritt: {
                wettbewerbId: null,
                kontaktEmail: null,
                anmerkungen: null,
                altersgruppe: null,
                ensemble: {
                    name: null,
                    ausbildungsinstitution: null,
                    leitung: {
                        vorname: null,
                        nachname: null,
                        geburtsdatum: null,
                        email: null,
                        telefonnummer: null,
                        geschlecht: null,
                    },
                    mitglieder: [
                        {
                            vorname: null,
                            nachname: null,
                            geburtsdatum: null,
                            email: null,
                            telefonnummer: null,
                            strasse: null,
                            plz: null,
                            ort: null,
                            geschlecht: null,
                        },
                        {
                            vorname: null,
                            nachname: null,
                            geburtsdatum: null,
                            email: null,
                            telefonnummer: null,
                            strasse: null,
                            plz: null,
                            ort: null,
                            geschlecht: null,
                        },
                        {
                            vorname: null,
                            nachname: null,
                            geburtsdatum: null,
                            email: null,
                            telefonnummer: null,
                            strasse: null,
                            plz: null,
                            ort: null,
                            geschlecht: null,
                        },
                    ]
                },
                musikstuecke: [
                    {
                        reihenfolge: 1,
                        titel: null,
                        titelderChoreographie: null,
                        komponist: null,
                        dauer: null,
                    },
                ],
            },
        }
    },
    watch: {
    },
    computed: {
    },
    methods: {
        async fetchWettbewerb() {
           const { data } = await this.service.wettbewerb.get(this.id).info()
           console.log(data)
           this.formdata.wettbewerb = data
        },
        addEnsembleMitglied: function () {
            this.wettbewerbsantritt.ensemble.mitglieder.push({
                vorname: null,
                nachname: null,
                geburtsdatum: null,
                email: null,
                geschlecht: null,
            })
        },

        addEnsembleStueck: function () {
            this.wettbewerbsantritt.musikstuecke.push({
                titel: null,
                komponist: null,
                dauer: null,
                kategorie: null,
            })
        },
        isOnStageTanz: function (){
            return this.id.toLowerCase() == 'onstagetanz';
        },
        maxTeilnehmer: function(){
            if(this.wettbewerbsantritt.wertungskategorie == 865250000)
                return 10;
            
            return 99;
        },

        removeEnsembleMitglied: function (index) {
            this.wettbewerbsantritt.ensemble.mitglieder.splice(index, 1)
        },

        removeEnsembleStueck: function (index) {
            this.wettbewerbsantritt.musikstuecke.splice(index, 1)
        },

        minimumMitglieder: function () {
            if(this.id.toLowerCase() == 'tanzimgespraech')
                return 2;
            return 3;
        },

        addToEnsembleLeiterInstrumente(e) {
            if (
                !this.wettbewerbsantritt.ensemble.leitung.instrumente.find(
                    inst => inst.id == e
                )
            )
                this.wettbewerbsantritt.ensemble.leitung.instrumente.push({
                    id: e,
                    name: this.formdata.instrumente.find(inst => inst.id == e)
                        .name,
                })
        },

        async fetchTextBausteine() {
            const { data } = await this.service.formular
                .get('volksmusik')
                .textbloeckePowerApps()
            this.formdata.textbausteine = data
        },

        async fetchMusikschulen() {
            const { data } = await this.service.musikschule.powerAppsAlle()
           
            this.formdata.musikschulen = data
            this.formdata.musikschulen.sort((a, b) =>
                a.kurzbezeichnung > b.kurzbezeichnung ? 1 : -1
            )
        },
        async fetchInstrumente() {
            const { data } = await this.service.fortbildungpowerapp.meta().instrumente()
            this.formdata.instrumente = data
        },
        altersgruppe() {      
             
            var gruppe = this.getAltersgruppe();

            return gruppe;
        },
        getAge(dateString) {
            if (!dateString)
                return null;

            var pattern = /(\d{1,2})\.(\d{1,2})\.(\d{4})/;
            var birthDate = new Date(dateString.replace(pattern, '$3-$2-$1'));

            var today = new Date(2024, 11, 31);
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }
            return age;
        },
        getAltersgruppe() {
            var ageOfGroup = 0;
            var maxAge = 0;
            for(let i = 0; i < this.wettbewerbsantritt.ensemble.mitglieder.length; i++){
                var ageOfMember = this.getAge(this.wettbewerbsantritt.ensemble.mitglieder[i].geburtsdatum)

                if(ageOfMember){
                    ageOfGroup += ageOfMember;
                    maxAge = maxAge > ageOfMember ? maxAge : ageOfMember;
                }
            }

            ageOfGroup = Math.floor(ageOfGroup / this.wettbewerbsantritt.ensemble.mitglieder.length);

            if (ageOfGroup <= 8 && maxAge <= 14)
                return {
                    name: "Junior",
                    stuecke: 3,
                    spielZeitMin: 0,
                    spielZeitMax: 2
                };
            if (ageOfGroup <= 11 && maxAge <= 16)
                return {
                    id: '',
                    name: "I",
                    stuecke: 4,
                    spielZeitMin: 2,
                    spielZeitMax: 4
                };
            if (ageOfGroup <= 13 && maxAge <= 18)
               return {
                    name: "II",
                    stuecke: 4,
                    spielZeitMin: 2,
                    spielZeitMax: 4
                };
            if (ageOfGroup <= 15 && maxAge <= 20)
                return {
                    name: "III",
                    stuecke: 5,
                    spielZeitMin: 4,
                    spielZeitMax: 6
                };
            if (ageOfGroup <= 17 && maxAge <= 22)
                return {
                    name: "IV",
                    stuecke: 5,
                    spielZeitMin: 4,
                    spielZeitMax: 6
                };
            if (ageOfGroup <= 20 && maxAge <= 24)
                return {
                    name: "V",
                    stuecke: 5,
                    spielZeitMin: 6,
                    spielZeitMax: 8
                };

            return {
                name: "---",
                stuecke: 0,
                spielZeitMin: 0,
                spielZeitMax: 90
            };
        },
        async sendAnsuchen() {
            var validation = await this.$refs.form.validate();

            if (!validation || this.musikstueckeValid() != '') {
                window.scrollTo(0, 0)
                this.formbehaviour.alertrequired = true
                return
            }

            try {
                if (!this.formbehaviour.begleitung1enabled)
                    this.wettbewerbsantritt.begleitung = null;

                this.formbehaviour.showSendModal = true
                this.formbehaviour.sending = true

                this.wettbewerbsantritt.wettbewerbId = this.formdata.wettbewerb.id;
                this.wettbewerbsantritt.altersgruppe = this.getAltersgruppe().name;
                
                this.wettbewerbsantritt.kontaktEmail = this.wettbewerbsantritt.ensemble.leitung.email;

                await this.service.wettbewerb.senden(this.wettbewerbsantritt)
                this.formbehaviour.showSendModal = false
                this.formbehaviour.successful = true

            } catch (error) {
                console.log(Object.keys(error), error.message)
                this.formbehaviour.successful = false
            } finally {
                this.formbehaviour.sending = false
                this.formbehaviour.showSendModal = false
            }
        },
        musikstueckeValid() {
            if(this.id.toLowerCase() == 'tanzimgespraech')
                return '';

            var altersgruppe = this.altersgruppe();

            if (altersgruppe == null)
                return 'Keine gültige Altersgruppe gefunden.';

            /*if (altersgruppe.stuecke > this.wettbewerbsantritt.musikstuecke.length)
                return 'Momentan sind zu wenige Musikstücke angegeben.';*/

            if(altersgruppe.name == '---')
                return 'Keine gültige Altersgruppe gefunden.';

            if(this.maxTeilnehmer() < this.wettbewerbsantritt.ensemble.mitglieder.length)
                return 'Das Ensemble hat zu viele Mitglieder';

            var gesamtdauer = 0;

            this.wettbewerbsantritt.musikstuecke.forEach(stueck => {
                if (stueck.dauer != null && stueck.dauer.indexOf(':') > -1)
                    stueck.dauerInMinuten = ((Number(stueck.dauer.split(':')[0]) * 60) + Number(stueck.dauer.split(':')[1])) / 60.0;
                else
                    stueck.dauerInMinuten = stueck.dauer;
                gesamtdauer += stueck.dauerInMinuten;
            });

            if (altersgruppe.spielZeitMin >= gesamtdauer)
                return 'Die Auftrittszeit ist zu kurz.';

            if (altersgruppe.spielZeitMax < gesamtdauer)
                return 'Die Auftrittszeit ist zu lang.';

            return '';
        },
        

        textbausteinfuer(id) {
            const found = this.formdata.textbausteine.find(
                element => element.identifier == id
            )

            if (!found) return id

            return found
        },

        async initData() {
            await this.fetchWettbewerb()
            await this.fetchMusikschulen()
            await this.fetchTextBausteine()
            await this.fetchInstrumente()
        },
    },
    created() {
        this.initData()
    },

    beforeDestroy() { },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
